import axios from 'axios'

export class JleagueApiClient {
    constructor() {
        this.baseURL = 'https://login-api2.jleague.jp';
        this.client = axios.create({
            baseURL: this.baseURL,
            headers: {
                "Authorization": "Bearer AAAAAAAAAAAAAAAAAAAAAAAA",
                "Content-Type": "application/json"
            },
            responseType: 'json'
        });
    }

    /**
     * 新規JリーグIDを作成する際に使用可能なIDかどうかをチェックする
     * - 会員情報変更時のように flp_token, email_token どちらも持たないときはリファラでチェックしている
     * @param {string} jleague_id JリーグID
     * @param {string} flp_token サーバから引き渡されてきたJWT
     * @param {string} email_token サーバから引き渡されてきたJWT
     * @returns {Promise<AxiosResponse<any>>}
     */
    checkAvailability(jleague_id, flp_token = '', email_token = '') {
        let params = {
            jleague_id: jleague_id
        };
        if (!!flp_token) {
            params['flp_token'] = flp_token
        }
        if (!!email_token) {
            params['email_token'] = email_token
        }
        return this.client.get('/check_availability', {
            params: params
        });
    };

    /**
     * MKDB ID を採番する
     * @param data
     * - email:         string
     * - email_token?:  string
     * - access_token?: string
     *
     * @returns {Promise<AxiosResponse<T>>}
     */
    postMKDB(data) {
        return this.client.post('/mkdb', data);
    }

    /**
     * 外部認証
     * @param data
     * - login_id
     * - password
     * - club_cd
     * - client_id
     *
     * @returns {Promise<AxiosResponse<T>>}
     */
    postExternalLogin(data) {
        return this.client.post('/external_login', {
            login_id: data.login_id,
            password: data.password,
            club_cd: data.club_cd,
            client_id: data.client_id,
        });
    }

    /**
     * 外部認証サインアップ
     * @param data
     * - token:     string
     * - club_cd:   string
     * - user_info: object
     * - mkdb_id:   string
     * - jl_otp_id: string
     * - password:  string
     *
     * @returns {Promise<AxiosResponse<T>>}
     */
    postExternalSignup(data) {
        return this.client.post('/external_signup', data);
    }

    /**
     * 外部ID紐付け
     * @param data
     * - login_id
     * - password
     * - club_cd
     * - mkdb_id
     * - access_token
     *
     * @returns {Promise<AxiosResponse<T>>}
     */
    postFlpRelation(data) {
        return this.client.post('/flp_relation', data);
    }
}
